export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SHOP_ID = 1;
export const DEFAULT_VISIBILITY = true;
export const DEFAULT_PARENT_ID = 1;

export const URL_ERROR_MAP = {
  required: 'required',
  urlTooLong: 'urlTooLong',
  urlReserved: 'urlReserved',
  urlInvalidFormat: 'urlFormatInvalid',
  notUnique: 'isNotUniqueUrl',
  urlTrailingSlash: 'urlTrailingSlash',
  urlSlugTooShort: 'urlSlugTooShort',
  urlInvalidStructure: 'urlStructureInvalid',
} as const;

export type UrlErrorKey = keyof typeof URL_ERROR_MAP;

export const CONFIRM_DELETE_CATEGORIES = {
  panelClass: 'confirm-dialog',
  data: {
    title: 'shop-settings.categories.deleteCategoryModal.title',
    desc: 'shop-settings.categories.deleteCategoryModal.deleteConfirm',
  },
} as const;
